// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/apps/pc/chat_widget.proto (package qliq_protobuf.apps.pc, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { LocalizedEntity } from "../../localized_entity_pb.ts";
import { ChatWidgetMessage } from "../../chat_widget_message_pb.ts";
import { Branding } from "../../branding_pb.ts";
import { Faq } from "../../faq_pb.ts";
import { ConversationRule } from "../../chat/conversation_rule_pb.ts";
import { Tracking } from "../../chat/tracking_pb.ts";
import { ChatWidgetAvailability } from "../../chat_widget_availability_pb.ts";

/**
 * @generated from message qliq_protobuf.apps.pc.ChatWidget
 */
export class ChatWidget extends Message<ChatWidget> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: repeated qliq_protobuf.LocalizedEntity name = 2;
   */
  name: LocalizedEntity[] = [];

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: bool disable_chat_attachments = 4;
   */
  disableChatAttachments = false;

  /**
   * @generated from field: bool disable_chat_emojis = 5;
   */
  disableChatEmojis = false;

  /**
   * @generated from field: uint32 maximum_attachment_size = 6;
   */
  maximumAttachmentSize = 0;

  /**
   * @generated from field: bool require_auth = 7;
   */
  requireAuth = false;

  /**
   * @generated from field: repeated string restrict_attachment_types = 8;
   */
  restrictAttachmentTypes: string[] = [];

  /**
   * @generated from field: repeated qliq_protobuf.ChatWidgetMessage messages = 9;
   */
  messages: ChatWidgetMessage[] = [];

  /**
   * @generated from field: qliq_protobuf.Branding branding = 10;
   */
  branding?: Branding;

  /**
   * @generated from field: repeated qliq_protobuf.Faq faqs = 11;
   */
  faqs: Faq[] = [];

  /**
   * @generated from field: qliq_protobuf.chat.ConversationRule conversation_rule = 12;
   */
  conversationRule?: ConversationRule;

  /**
   * @generated from field: qliq_protobuf.chat.Tracking tracking = 13;
   */
  tracking?: Tracking;

  /**
   * @generated from field: bool show_faqs_on_help_screen = 14;
   */
  showFaqsOnHelpScreen = false;

  /**
   * @generated from field: bool show_tac_message_on_help_screen = 15;
   */
  showTacMessageOnHelpScreen = false;

  /**
   * @generated from field: bool show_emergency_notification_on_help_screen = 16;
   */
  showEmergencyNotificationOnHelpScreen = false;

  /**
   * @generated from field: bool show_about_message_on_help_screen = 17;
   */
  showAboutMessageOnHelpScreen = false;

  /**
   * @generated from field: bool show_escalate_to_agent_button = 18;
   */
  showEscalateToAgentButton = false;

  /**
   * @generated from field: repeated qliq_protobuf.apps.pc.ChatWidget.Agent online_agents = 19;
   */
  onlineAgents: ChatWidget_Agent[] = [];

  /**
   * @generated from field: qliq_protobuf.ChatWidgetAvailability chat_widget_availability = 20;
   */
  chatWidgetAvailability?: ChatWidgetAvailability;

  /**
   * @generated from field: bool is_post_video_call_feedback_enabled = 21;
   */
  isPostVideoCallFeedbackEnabled = false;

  /**
   * @generated from field: bool hide_old_conversation_for_patient_visitor = 22;
   */
  hideOldConversationForPatientVisitor = false;

  /**
   * @generated from field: bool hide_assignment_banners = 23;
   */
  hideAssignmentBanners = false;

  /**
   * @generated from field: bool show_assignee = 24;
   */
  showAssignee = false;

  /**
   * @generated from field: bool is_available = 25;
   */
  isAvailable = false;

  /**
   * @generated from field: bool is_one_conversation_per_patient_or_visitor = 26;
   */
  isOneConversationPerPatientOrVisitor = false;

  /**
   * @generated from field: bool escalate_to_agent_button = 27;
   */
  escalateToAgentButton = false;

  /**
   * @generated from field: bool can_start_new_conversation = 28;
   */
  canStartNewConversation = false;

  /**
   * @generated from field: bool is_kiosk_mode_enabled = 29;
   */
  isKioskModeEnabled = false;

  /**
   * @generated from field: string kiosk_mode_landing_url = 30;
   */
  kioskModeLandingUrl = "";

  constructor(data?: PartialMessage<ChatWidget>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.ChatWidget";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "name", kind: "message", T: LocalizedEntity, repeated: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "disable_chat_attachments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "disable_chat_emojis", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "maximum_attachment_size", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 7, name: "require_auth", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "restrict_attachment_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "messages", kind: "message", T: ChatWidgetMessage, repeated: true },
    { no: 10, name: "branding", kind: "message", T: Branding },
    { no: 11, name: "faqs", kind: "message", T: Faq, repeated: true },
    { no: 12, name: "conversation_rule", kind: "message", T: ConversationRule },
    { no: 13, name: "tracking", kind: "message", T: Tracking },
    { no: 14, name: "show_faqs_on_help_screen", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "show_tac_message_on_help_screen", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "show_emergency_notification_on_help_screen", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "show_about_message_on_help_screen", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "show_escalate_to_agent_button", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "online_agents", kind: "message", T: ChatWidget_Agent, repeated: true },
    { no: 20, name: "chat_widget_availability", kind: "message", T: ChatWidgetAvailability },
    { no: 21, name: "is_post_video_call_feedback_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 22, name: "hide_old_conversation_for_patient_visitor", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 23, name: "hide_assignment_banners", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 24, name: "show_assignee", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 25, name: "is_available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 26, name: "is_one_conversation_per_patient_or_visitor", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 27, name: "escalate_to_agent_button", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 28, name: "can_start_new_conversation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 29, name: "is_kiosk_mode_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 30, name: "kiosk_mode_landing_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChatWidget {
    return new ChatWidget().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChatWidget {
    return new ChatWidget().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChatWidget {
    return new ChatWidget().fromJsonString(jsonString, options);
  }

  static equals(a: ChatWidget | PlainMessage<ChatWidget> | undefined, b: ChatWidget | PlainMessage<ChatWidget> | undefined): boolean {
    return proto3.util.equals(ChatWidget, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.apps.pc.ChatWidget.Agent
 */
export class ChatWidget_Agent extends Message<ChatWidget_Agent> {
  /**
   * @generated from field: uint32 chat_user_id = 1;
   */
  chatUserId = 0;

  constructor(data?: PartialMessage<ChatWidget_Agent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.pc.ChatWidget.Agent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chat_user_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChatWidget_Agent {
    return new ChatWidget_Agent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChatWidget_Agent {
    return new ChatWidget_Agent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChatWidget_Agent {
    return new ChatWidget_Agent().fromJsonString(jsonString, options);
  }

  static equals(a: ChatWidget_Agent | PlainMessage<ChatWidget_Agent> | undefined, b: ChatWidget_Agent | PlainMessage<ChatWidget_Agent> | undefined): boolean {
    return proto3.util.equals(ChatWidget_Agent, a, b);
  }
}

